import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, Injectable, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

const I18N_VALUES = {
  fr: {
    weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
    months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
    weekLabel: 'sem'
  },
  en: {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Agu', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekLabel: 'sem'
  }
};

@Injectable()
export class I18n {
  language = this.translateService.currentLang;

  constructor(private translateService: TranslateService, private changeDetectorRef: ChangeDetectorRef) {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.language = event.lang;
      this.changeDetectorRef.detectChanges();
    });
  }
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private i18n: I18n) { super(); }

  getWeekdayShortName(weekday: number): string { return I18N_VALUES[this.i18n.language].weekdays[weekday - 1]; }
  getWeekLabel(): string { return I18N_VALUES[this.i18n.language].weekLabel; }
  getMonthShortName(month: number): string { return I18N_VALUES[this.i18n.language].months[month - 1]; }
  getMonthFullName(month: number): string { return this.getMonthShortName(month); }
  getDayAriaLabel(date: NgbDateStruct): string { return `${date.day}-${date.month}-${date.year}`; }
}
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers:
    [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})

export class CalendarComponent implements OnInit {

  model: NgbDateStruct;
  today: any;
  yesterday: any;
  tomorrow: string;
  showCalendar = true;
  date: { year: number, month: number };
  displayMonths = 1;
  navigation = 'arrow';
  format = 'yyyy-MM-dd';
  locale = 'en-US';

  constructor(private router: Router, private translateService: TranslateService) {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.showCalendar = false;
      setTimeout(() => {
        this.showCalendar = true;
      }, 50);
    });
  }

  ngOnInit(): void {
    this.today = formatDate(new Date(), this.format, this.locale);
    this.yesterday = formatDate(new Date().setDate(new Date().getDate() - 1), this.format, this.locale);
    this.tomorrow = formatDate(new Date().setDate(new Date().getDate() + 1), this.format, this.locale);
  }

  navigateRaces(navDate): any {
    if (navDate === this.today) {
      this.router.navigateByUrl('races');
    } else {
      this.router.navigateByUrl('races/' + navDate);
    }
  }

  onDateSelect(event): any {
    const newDate = formatDate(this.model.year + '-' + this.model.month + '-' + this.model.day, this.format, this.locale);
    this.router.navigateByUrl('races/' + newDate);
  }
}
